export default "__VITE_ASSET__KU2S1uUJ__"